module.exports = __webpack_public_path__ + "images/file_icons_v2/mp3-cbc24fbf0323b0ac302e8c50024f6120.svg";